import {loadGamesAsync} from '../../services/api/games';
import {getCurrentLocale} from '../../utils/i18n';

export const LOAD_GAMES_START = 'LOAD_GAMES_START';
export const LOAD_GAMES_ERROR = 'LOAD_GAMES_ERROR';
export const LOAD_GAMES_COMPLETE = 'LOAD_GAMES_COMPLETE';

export const DISPLAY_NEXT_IN_FULLSCREEN = 'DISPLAY_NEXT_IN_FULLSCREEN';

export const loadGames = () => async (dispatch, getState) => {
    dispatch({type: LOAD_GAMES_START});

    try {
        let locale = getCurrentLocale();
        let games = await loadGamesAsync(
            locale === 'por' ? 'por' : 'spa',
            'DKIDS',
        );
        dispatch({type: LOAD_GAMES_COMPLETE, games});
    } catch (error) {
        dispatch({type: LOAD_GAMES_ERROR, error});
    }
};

export const displayNextInFullScreen = flag => async dispatch => {
    dispatch({type: DISPLAY_NEXT_IN_FULLSCREEN, nextInFullScreen: flag});
};
